import React from 'react';
import { AppViewRouterProps } from './types';
import { ProjectCoreViewsRouter } from './ProjectCoreViewsRouter';
import { ProjectAuxViewsRouter } from './ProjectAuxViewsRouter';

export const ProjectViewsRouter: React.FC<AppViewRouterProps> = (props) => {
  return (
    <>
      <ProjectCoreViewsRouter {...props} />
      <ProjectAuxViewsRouter {...props} />
    </>
  );
};

export default ProjectViewsRouter;
